var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    {
      attrs: {
        size: "mini",
        placeholder: "Sélection",
        filterable: "",
        clearable: ""
      },
      on: {
        change: function($event) {
          return _vm.onChange($event)
        },
        clear: function($event) {
          return _vm.onClear()
        }
      },
      model: {
        value: _vm.id_client,
        callback: function($$v) {
          _vm.id_client = $$v
        },
        expression: "id_client"
      }
    },
    _vm._l(_vm.clients, function(item) {
      return _c(
        "el-option",
        { key: item.id, attrs: { label: item.libelle, value: item.id } },
        [
          _c("span", { staticStyle: { float: "left" } }, [
            _vm._v(_vm._s(item.libelle) + "   ")
          ]),
          _vm._v(" "),
          _c(
            "span",
            {
              staticStyle: {
                float: "right",
                color: "#8492a6",
                "font-size": "13px"
              }
            },
            [_vm._v(_vm._s(item.code))]
          )
        ]
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }